import { render, staticRenderFns } from "./LiabilitiesDetailsTable.vue?vue&type=template&id=654ef2d8&scoped=true&"
import script from "./LiabilitiesDetailsTable.vue?vue&type=script&lang=js&"
export * from "./LiabilitiesDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./LiabilitiesDetailsTable.vue?vue&type=style&index=0&id=654ef2d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654ef2d8",
  null
  
)

export default component.exports